.stack {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-4);
}

.muted {
  color: var(--color-grey);
  font-size: var(--font-size-m);
}

.hint {
  font-size: var(--font-size-m);
  color: var(--color-grey);
  margin-bottom: var(--spacing-3);
  line-height: 1.5;
  max-width: 720px;
}

.list {
  display: flex;
  flex-direction: column;
}

.row {
  display: flex;
  align-items: center;
  gap: var(--spacing-3);
  padding: 10px 0;
}

.row:not(:last-child) {
  border-bottom: 1px solid var(--color-grey-lightest);
}

.main {
  flex: 1;
  min-width: 0;
}

.name {
  font-size: var(--font-size-m);
  color: var(--color-text);
}

.sub {
  font-size: var(--font-size-s);
  color: var(--color-grey);
  margin-top: 1px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.actions {
  display: flex;
  gap: var(--spacing-2);
  flex-shrink: 0;
}

.grow {
  flex: 1;
}

/* ── duplicate-e-mail groups ── */
.dupList {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-3);
}

.dupGroup {
  border: 1px solid var(--color-grey-lighter);
  border-radius: var(--border-radius-m);
  padding: 11px 14px;
}

.dupHead {
  display: flex;
  align-items: center;
  gap: var(--spacing-2);
  flex-wrap: wrap;
}

.dupEmail {
  font-family: ui-monospace, SFMono-Regular, Menlo, monospace;
  font-size: var(--font-size-m);
  color: var(--color-text);
}

.dupNote {
  font-size: var(--font-size-s);
  color: var(--color-warning);
  margin-top: 6px;
}

.dupAccounts {
  display: flex;
  flex-direction: column;
  margin-top: 8px;
}

.dupAccount {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 6px 0;
}

.dupAccount:not(:last-child) {
  border-bottom: 1px solid var(--color-grey-lightest);
}

.dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  flex-shrink: 0;
}

.dotReady {
  background: var(--color-success);
}

.dotIdle {
  background: var(--color-grey-lighter);
}

.dupName {
  font-size: var(--font-size-m);
  color: var(--color-text);
}

.dupMeta {
  font-size: var(--font-size-s);
  color: var(--color-grey);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
